module.exports = __webpack_public_path__ + "img/ostosraha.cdcf095.png";